import {useQuery} from "@tanstack/react-query";
import getThirtyDaysLeaderboard from "../api/getThirtyDaysLeaderboard";

const useGetThirtyDaysLeaderboard = () => {
  const {
    data: dataThirtyDaysLeaderboard,
    isLoading: thirtyDaysLeaderboardIsLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["getThirtyDaysLeaderboard"],
    queryFn: getThirtyDaysLeaderboard,
  });

  return {
    dataThirtyDaysLeaderboard,
    thirtyDaysLeaderboardIsLoading,
    isError,
    error,
  };
};

export default useGetThirtyDaysLeaderboard;
